import React from 'react';
import { FileUploader } from '@nimbus-ds/components';

function ChargebackDocumentUploaderSkeleton(): JSX.Element {
  return (
    <FileUploader.Skeleton aspectRatio="none" height="180px" width="100%" />
  );
}

export default ChargebackDocumentUploaderSkeleton;
